import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline";

import Button, { EButtonColor, EButtonSize, EButtonVariant } from "components/elements/Button";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";

type IProps = {
	onClick?: () => void;
};

export default function FilterButton(props: IProps) {
	return (
		<Button
			variant={EButtonVariant.CONTAINED}
			color={EButtonColor.PRIMARY}
			size={EButtonSize.LARGE}
			startIcon={<AdjustmentsHorizontalIcon />}
			onClick={props.onClick}>
			<Typography type="span" weight="semi-bold" size="large">
				{I18n.trslt(I18n.asset.pages.projects.filter_button)}
			</Typography>
		</Button>
	);
}
